function buocNhapXuatKho() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Nhập / xuất kho Sọt",
      content:
        "Nhân viên kho quét QR trên Sọt. Hệ thống tự nhận đây là nhập kho (Sọt mới thu mua) hay xuất kho (Sọt đã trong kho, cân lại sau ủ) — không cần chọn tay.",
    },
    {
      target: "#tour-kho-che-do-quet",
      title: "Bước 2 · Quét hoặc nhập mã",
      content:
        "Quét QR dán trên Sọt (hoặc nhập tay mã QR). Sau khi nhận diện, cân lại Sọt, nhập số cân thực tế rồi bấm xác nhận để ghi lịch sử kho.",
      placement: "bottom",
    },
  ];
}

export default buocNhapXuatKho;
